import { defineComponent as _defineComponent } from 'vue'
import { useDonationFormsStore } from '../store';

export default /*@__PURE__*/_defineComponent({
  __name: 'RecurringCycle',
  props: {
  options: {
      type: Object,
      default: () => {
        return {
          weekly: 'Weekly',
          monthly: 'Monthly',
          quarterly: 'Quarterly',
          yearly: 'Yearly',
        }
      }
    }
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;
const store = useDonationFormsStore();




const __returned__ = { props, store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})